module.exports = __webpack_public_path__ + "fonts/AZhuPaoPaoTi-2.4a925ab7.ttf";